import isBrowser from 'utils/isBrowser';
import { getNewRelicAgent } from 'utils/logging/getNewRelicAgent';
import { newRelicLogger } from 'utils/logging';
import { TrackJS } from 'utils/trackjs-isomorphic';
import { ErrorMeta, ErrorPriority } from 'types';

const TRIGGERED_ERROR_MAP: Record<string, boolean> = {};

function _hasAlreadyLoggedThisSession(error: string | Error): boolean {
  try {
    const message = error.toString();
    if (!isBrowser()) {
      return false;
    }

    if (TRIGGERED_ERROR_MAP[message]) {
      return true;
    }

    TRIGGERED_ERROR_MAP[message] = true;
    return false;
  } catch {
    return false;
  }
}

export function LogError(
  error: string | Error,
  meta: ErrorMeta = { priority: ErrorPriority.ONE }
): void {
  const _meta = meta;

  if (_hasAlreadyLoggedThisSession(error)) {
    return;
  }

  if (!_meta.priority) {
    // eslint-disable-next-line no-param-reassign
    _meta.priority = ErrorPriority.ONE;
  }

  getNewRelicAgent().then((agent) => {
    if (agent && agent.noticeError) {
      agent.noticeError(error, _meta);
      newRelicLogger(
        typeof error === 'string' ? error : error.message,
        'error',
        _meta
      );
    }
  });

  if (TrackJS.isInstalled()) {
    Object.keys(_meta).forEach((key: string) => {
      TrackJS.addMetadata(key, _meta[key as keyof ErrorMeta] as string);
    });

    TrackJS.track(error);

    // Removing as to not let meta values bleed into other errors
    Object.keys(_meta).forEach((key) => {
      TrackJS.removeMetadata(key);
    });
  }
}
